import Immutable from 'immutable';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';
import { SET_COURSE_LANDING_PAGE_DATA } from '../Courses/actions';
import { FETCH_PORTAL_SUCCESS } from '../PortalAdmin/actions';
import {
  WASABI_SEARCH_INSTITUTIONS_SUCCESS,
  WASABI_FETCH_INSTITUTION_SUCCESS,
} from '../Wasabi/actions';

const DEFAULT_STATE = Immutable.fromJS({
  byPath: {},
});

export function Portals(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case FETCH_PORTAL_SUCCESS: {
      const { portal, portalPath } = action;
      return state.setIn(['byPath', portalPath], Immutable.fromJS(portal));
    }
    case WASABI_SEARCH_INSTITUTIONS_SUCCESS:
    case COURSE_NAVIGATION_DATA_SET: {
      let newState = state;

      action.portals.forEach((portal) => {
        newState = newState.setIn(
          ['byPath', portal.name],
          Immutable.fromJS(portal)
        );
      });

      return newState;
    }
    case WASABI_FETCH_INSTITUTION_SUCCESS:
    case SET_COURSE_LANDING_PAGE_DATA: {
      const { portal } = action;
      let newState = state;
      if (portal) {
        newState = newState.mergeIn(
          ['byPath', portal.name],
          Immutable.fromJS(portal)
        );
      }
      return newState;
    }
    default: {
      return state;
    }
  }
}
